import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';
import aplCatlCode from '@/json/aplCatlCode';
import codeList from '@/json/codeList';

const code = codeList.LINEPNP;
const aplCatl = aplCatlCode.PON4300;

export const routesLinePnp = [
    {
        path: 'linepnp',
        name: routeName.LINEPNP,
        component: () => import('@/views/linePnp/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: 'linePnp', leaveAlert: false, code },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.HOME, routeName.SSO_PAGE, routeName.SSO_SCV, routeName.SSO_MOBILE];
            const guideRoute = guideRoutes(from, whiteList, true, aplCatl);
            next(guideRoute);
        },
    },
];
